module.exports = __webpack_public_path__ + "img/pascal-le-rest.b45d711c.jpg";